import React, { FC } from 'react'
import styles from './Custom.module.scss'

type CustomProps = {
  data: string
}

export const Custom: FC<CustomProps> = ({ data }) => {
  return <div className={styles.customLegend} dangerouslySetInnerHTML={{ __html: data }} />
}

Custom.displayName = 'Custom'
